// extracted by mini-css-extract-plugin
export var paginationContainer = "_84-0";